import { PrimeNGConfig } from "primeng/api";

/** Au-delà : tooltips, toasts, Intercom ; ignorés par les panneaux qui scannent le DOM. */
export const OVERLAY_Z_INDEX_CEILING = 1_000_000;

/** Cale les couches PrimeNG sur celles d'eva-dialog (carte en tête d'eva-dialog.component.ts). */
export function applyEvaZIndexLayers(config: PrimeNGConfig): void {
  config.zIndex = { modal: 15000, overlay: 20000, menu: 20000, tooltip: 21000 };
}
